import cloneDeep from 'lodash.clonedeep';
import uniqBy from 'lodash.uniqby';
import { AutoCompleteService } from './../../../../shared/services/auto-complete.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferencesService } from '../../services/preferences.service';
import { PreferenceMessages } from '../../../../shared/models/component-messages/preference-messages';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Preference, Value } from '../../model/preference';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../../shared/modals/information/information.component';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './preference-cpv-detail.component.html',
  styleUrls: ['./preference-cpv-detail.component.scss']
})
export class PreferenceCpvDetailComponent implements OnInit, OnDestroy {

  retourUrl: string = '/preferencesAvisPub';

  public preferenceMessages = new PreferenceMessages();

  private unsubscribe$ = new Subject<void>();

  public form: FormGroup;

  searchValue: string;

  preferenceOriginal: Preference = new Preference;
  preference: Preference = new Preference;

  action: string;
  id: string;
  cpvListOriginal: any;
  cpvList: any;
  cpvListTmp: any = [];

  limitMaxCpv: number = 36;

  constructor(private modalService: NgbModal, private preferenceService: PreferencesService, private router: Router, private route: ActivatedRoute, private autoCompleteService: AutoCompleteService, private translateService: TranslateService,) { }

  ngOnInit(): void {
    this.form = new FormGroup({});
    this.initParam();
    this.getAllCpv();
    if (this.action === "modifier") {
      this.getPreference();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.cpvList?.forEach(e => {
      e.status = false;
    });
  }

  initParam(): void {
    this.action = this.route?.routeConfig?.data?.action
    if (this.action === "modifier") {
      this.id = this.route?.snapshot?.paramMap?.get('id');
    }
  }

  getPreference() {
    this.preferenceService.getByIdCpv(this.id).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.preference = data;
          this.preferenceOriginal = cloneDeep(data);
          this.form.get("preference_SepAtt_cpv_SepAtt_intitule")?.setValue(this.preference.titre);
        })
      })
  }

  retour(): void {
    this.router.navigate(['/preferencesAvisPub']);
  }

  getAllCpv(): void {
    this.autoCompleteService.cpv$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(cpv => {
        this.cpvListOriginal = cpv;
      });
  }

  reset(): void {
    this.preference.content.values = new Array;
  }

  savePref(): void {
    let prefToSave = new Preference;
    prefToSave.titre = this.form.get("preference_SepAtt_cpv_SepAtt_intitule")?.value;
    prefToSave.content = this.preference.content;
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.OkOuRetour = true;
    if (this.action === "ajouter") {
      modalRef.componentInstance.content = this.preferenceMessages.modal_create_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.createCpv(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                })
            }
          })
        })
    }
    if (this.action === "modifier") {
      prefToSave.id = Number(this.id);
      modalRef.componentInstance.content = this.preferenceMessages.modal_update_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.updateCpv(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                })
            }
          })
        })
    }
  }

  delete(obj: Value): void {
    this.preference.content.values = this.preference.content.values.filter(item => item !== obj);
  }

  partageReturn(event) {
    if (event.type === PreferenceType.CODES_CPV) {
      this.router.navigate([location.pathname + '/' + event.id]);
    } else {
      this.router.navigate(['/preferencesAvisPub']);
    }
  }

  selectCount(): number {
    if (this.preference?.content?.values?.length !== undefined) {
      return this.preference?.content?.values?.length;
    } else {
      return 0;
    }
  }

  cpvCount(): number {
    if (this.cpvList?.length !== undefined) {
      return this.cpvList?.length;
    } else {
      return 0;
    }
  }

  annuler(): void {
    this.preference = cloneDeep(this.preferenceOriginal);
    this.form.get("preference_SepAtt_cpv_SepAtt_intitule")?.setValue(this.preference.titre);
  }

  search(searchValue: string) {
    this.cpvListTmp = [];
    this.cpvList?.forEach(e => {
      e.status = false;
    });
    this.cpvList = new Array;
    if (searchValue !== "" && searchValue !== undefined) {
      this.cpvListOriginal.forEach(element1 => {
        if (element1.code?.search(new RegExp(searchValue, "i")) != -1
          || this.translateService.instant(element1.libelle)?.search(new RegExp(searchValue, "i")) != -1
        )
          this.cpvList.push(element1);
      });
    }
  }

  addCpv(): void {
    let tab: Value[] = [];
    this.cpvListTmp.forEach(e => {
      const v: Value = new Value();
      v.code = e.code;
      v.value = e.libelle;
      tab.push(v);
    });
    const arr = uniqBy([...this.preference.content.values, ...tab], JSON.stringify)
    this.preference.content.values = arr;

    this.searchValue="";
    this.search(this.searchValue);
  }

  changeCheckbox(item: any): void {
    if (item.status) {
      this.cpvListTmp.push(item);
    } else {
      this.cpvListTmp = this.cpvListTmp.filter(e => e !== item)
    }
  }
}
